<template>
  <ViewAndEdit
    v-model="selectedOperatorString"
    label="Operator"
    mode="edit"
    :attributes="{ type: 'select', options: currentOptions }"
    @update:model-value="onOperatorChange"
  />
  <ConditionValue
    v-if="currentOperatorDefinition"
    :index="index"
    :operator-definition="currentOperatorDefinition"
    :selected-operator="selectedOperatorString"
    :selected-property="selectedProperty"
    :expression-condition="expressionCondition"
  />
</template>

<script setup lang="ts">
import ViewAndEdit from '../common/ViewAndEdit.vue';
import ConditionValue from './ConditionValue.vue';
import type { WorkflowDefinitionConditionEntity } from '@/api/entity_types/workflow/WorkflowDefinition';
import { useConditionOperator } from './useConditionOperator';
import type { WorkflowExpressionCondition } from '@/api/entity_types/workflow/WorkflowCondition';

export type ConditionOperatorProps = {
  selectedProperty: string;
  conditionDefinition: WorkflowDefinitionConditionEntity;
  expressionCondition: WorkflowExpressionCondition;
  index: number;
};

const props = defineProps<ConditionOperatorProps>();

const { selectedOperatorString, currentOperatorDefinition, currentOptions, onOperatorChange } =
  useConditionOperator(props);
</script>
